import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import GenericCrudServiceV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2, { HttpClientV2Config } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { ProductFlowDeliverable } from "@/models/ProductFlowDeliverable";
import { ProductFlowDeliverableCreationRequest } from "@/models/ProductFlowDeliverableCreationRequest";
import moment from "moment";

class ProductFlowDeliverableService extends GenericCrudServiceV2<ProductFlowDeliverable> {
  path: string;
  constructor(path: string) {
    super(path);
    this.path = path;
  }

  async getAllDeliverablesOfProductFlow(productFlowExternalId: string): Promise<ApiResponseV2<ProductFlowDeliverable[]>> {
    return HttpClientV2.get(`${this.path}/all/${productFlowExternalId}`);
  }

  async createDeliverable(requestDTO: ProductFlowDeliverableCreationRequest): Promise<ApiResponseV2<ProductFlowDeliverable>> {
    const formData = new FormData();
    Object.keys(requestDTO).forEach((k) => {
      if (k === "files") return;
      if ((k === "renewAt" || k === "dueDate" || k === "dueDateExtension") && requestDTO[k]) {
        // ISO_8601 for OffsetDateTime
        formData.set(k, moment(requestDTO[k] as Date).format("YYYY-MM-DDTHH:mm:ssZ"));
        return;
      }
      formData.set(k, requestDTO[k]);
    });
    requestDTO.files.forEach((f) => formData.append("files", f));
    return HttpClientV2.post(`${this.path}/create`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    } as HttpClientV2Config);
  }

  async deleteDeliverable(productFlowDeliverableExternalId: string): Promise<ApiResponseV2<ProductFlowDeliverable>> {
    return HttpClientV2.delete(`${this.path}/delete/${productFlowDeliverableExternalId}`);
  }
  async AddDeliverableToProductFlow(productFlowDeliverableExternalId: string, file: File): Promise<ApiResponseV2<ProductFlowDeliverable>> {
    const formData = new FormData();
    formData.append("file", file);
    return HttpClientV2.post(`${this.path}/add-deliverable-file/${productFlowDeliverableExternalId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    } as HttpClientV2Config);
  }
  async deleteDeliverableFile(deliverableExternalId: string, fileExternalId: string): Promise<ApiResponseV2<ProductFlowDeliverable>> {
    return HttpClientV2.delete(`${this.path}/delete-selected-deliverable-file/${fileExternalId}/${deliverableExternalId}`);
  }

  async updateRenewalDate(productFlowDeliverableExternalId: string, renewalDate: string): Promise<ApiResponseV2<ProductFlowDeliverable>> {
    return HttpClientV2.put(`${this.path}/update-renewal-date/${productFlowDeliverableExternalId}?renewalDate=${renewalDate}`, null);
  }
}

export default new ProductFlowDeliverableService("/api/product-flow-deliverable");
